import { useMutation, useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "../apiService";

export const useGetSimulationFarmGateProcessDataById = (
  farmGateProcessId: any
) =>
  useQuery(
    ["getSimulationFarmGateProcessDataById"],
    async () => {
      const response = await axiosApi.get(
        `/farm-gate/processing/${farmGateProcessId}`
      );
      return response?.data;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!farmGateProcessId,
    }
  );

export const usePutSimulationFarmGateProcessData = (data?: any) => {
  return useMutation<string, ApiServiceErr, any>(async (data) => {
    const response = await axiosApi.put(
      `/farm-gate/processing/${data?.farmGateId}`,
      data
    );
    return response.data;
  });
};

export const usePostSimulationFarmGateProcessData = (data?: any) => {
  return useMutation<string, ApiServiceErr, any>(async (data) => {
    const response = await axiosApi.post(
      `/farm-gate/processing/${data?.farmGateId}`,
      data
    );
    return response.data;
  });
};

export const useDeleteSimulationFarmGateProcessData = (data?: any) => {
  return useMutation<string, ApiServiceErr, any>(async (data) => {
    const response = await axiosApi.delete(
      `/farm-gate/processing/${data?.processId}?farmGateId=${data?.farmGateId}`
    );
    return response.data;
  });
};

export const useGetSimulationProcessRecipeByProcessId = (data: {
  recipeId: string;
  type: string;
}) =>
  useQuery(
    ["getSimulationProcessRecipeByProcessId"],
    async () => {
      const response = await axiosApi.get(
        `/${data.type}/recipe/${data.recipeId}`
      );
      return response?.data;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!data.recipeId,
    }
  );
